module.exports = __webpack_public_path__ + "img/39.f10baf30.png";